import { requireService } from '@profgeosoft/di-ez';
import { CopyAltLight } from '@repo/go-icons';
import { Button } from '@repo/go-ui';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { wrap } from 'src/packages/mobx-di/wrap';

import type { MainDirectoryService } from 'src/services/directory-service/main-directory-service';
import type { TActionButtonView } from 'src/services/directory-service/types';

import { CopyToAnotherRoomModal } from './copy-to-another-room-modal';
import { CopyToAnotherRoomStore } from './copy-to-another-room.store';

import styles from './copy-to-another-room-modal.module.scss';

type Props = {
  view: TActionButtonView;
  directory: MainDirectoryService;
};

export const CopyToAnotherRoom = wrap<Props>(function CopyToAnotherRoom({ view, directory }) {
  const { t, i18n } = useTranslation();
  const { isEditing } = requireService('directoryPage');
  const mainServices = requireService('mainServices');
  const buttonName = i18n.exists(`labels:${view.fieldId}.label`)
    ? t(`labels:${view.fieldId}.label`)
    : t('directory:components.copyToAnotherRoom.copyData');

  const [store] = useState(() => new CopyToAnotherRoomStore(mainServices, directory, view));

  const handleOpen = () => {
    store.prefillControls();
    store.setIsOpened(true);
  };

  if (isEditing) {
    return null;
  }

  return (
    <>
      <Button icon={<CopyAltLight />} onClick={handleOpen}>
        <p className={styles.buttonText}>{buttonName}</p>
      </Button>
      <CopyToAnotherRoomModal store={store} optionsService={directory.optionsService} />
    </>
  );
});
